<template>
  <q-card class="bg-primary q-pa-sm">
    <q-card-section class="q-py-sm q-px-none" style="height: 65px;">
      <div class="float-left">
        <img src="https://nadiablob.blob.core.windows.net/assets/shield.png" width="40px" />
      </div>
      <div class="text-white text-bold q-pl-xl">
        TAC VERIFICATION
        <br />
        <p>This transaction requires a TAC</p>
      </div>
    </q-card-section>

    <q-card>
      <q-card-section>
        
        <q-form @submit="verifyTac">

          <div class="row items-center q-pb-md">
            <div class="col-xs-12 col-sm-4 col-md-4 tac-image">
              <img class="responsive" src="https://nadiablob.blob.core.windows.net/assets/tac.png" alt />
            </div>

            <div class="col-xs-12 col-sm-8 col-md-8 q-pt-sm">
              <p class="text-h5">You’re almost there!</p>
              <p>Kindly click the 'Request TAC' button so that a TAC code will be sent to {{ mobileNoMask ? mobileNoMask : '###########' }} for authorization.</p>
              <p>Please do not leave this page while waiting for the TAC code. If you did not receive the TAC code in the next {{ validityInMinutes }} minutes, click ‘Request TAC’ again for a fresh TAC code.</p>

              <div class="row justify-start">
                <div class="col-xs-12 col-sm-12 col-md-12 q-pt-sm">
                  
                  <q-input
                    v-model="tac"
                    dense
                    outlined
                    type="password"
                    label="Enter TAC"
                    mask="######"
                    lazy-rules
                    :rules="[
                      val => val !== '' && val !== null,
                      val => val.length >= 6 || 'Minumum character is 6',
                    ]"
                  />
                  
                  <q-btn
                    unelevated 
                    no-caps
                    class="tac-btn "
                    align="center"
                    :loading="isRequesting"
                    color="primary"
                    size="sm"
                    @click="requestTac"
                    label="Request TAC"
                    :disable="mobileNo === ''"
                  >
                    <template v-slot:loading v-if="timer > 0">
                      <q-spinner-hourglass /> {{ countDownTimerMask }}
                    </template>
                  </q-btn>

                </div>
              </div>
            </div>
          </div>

          <q-card-actions align="center">
            <q-btn color="negative" type="button" label="Cancel" @click="cancel" />
            <q-btn color="primary" type="submit" label="Verify" :disable="!isRequested" />
          </q-card-actions>

        </q-form>

      </q-card-section>
    </q-card>
  </q-card>
</template>

<script>
import axios from "axios";
import { QSpinnerHourglass, QCard, QCardSection, QBtn, QInput } from 'quasar'
export default {
  name: "TAC",

  components: {
    QSpinnerHourglass,
    QCard,
    QCardSection,
    QBtn,
    QInput
  },

  props: {
    customerId: String,
    idType: String,
    purpose: String,
    validityInMinutes: Number,
    env: { type: String, required: false, default: 'development' },
    apiUrl: { type: String, required: true },
    notificationAPIToken: { type: String, required: true },
    cifAPIToken: { type: String, required: true }
  },

  data() {
    return {
      tac: "",
      mobileNo: '',
      isRequested: false,
      isVerified: false,
      isRequesting: false,
      timer: 0
    };
  },

  methods: {
    requestTac() {

      this.$set(this, "isRequesting", true);
      this.$set(this, 'timer', this.validityInMinutes * 60)
      this.countDownTimer()

      // Bypass api call if env === dev
      if (this.env !== 'production') {
        return this.$set(this, "isRequested", true);
      }

      axios({
        method: "POST",
        url: this.apiUrl + '/notification/tacbycustomer',
        headers: { Authorization: "Bearer " + this.notificationAPIToken },
        data: {
          CustomerID: this.customerId,
          ValidityInMinute: this.validityInMinutes,
          Purpose: this.purpose,
          RequestorID: this.customerId,
          RequestorIDType: this.idType
        }
      })
      .then(resp => {
        this.$set(this, "isRequested", resp.data.isSuccessful);
      })
      .catch(err => {
        console.log(err);
        this.$set(this, "isRequesting", false);
          this.$q.dialog({
            title: 'Error',
            message: `There seems to be a problem requesting your tac. Please try again later.`,
            persistent: true
          })
      });
    },

    async verifyTac() {

      // Emit dummy status if env === dev
      if (this.env !== 'production') {
        return this.$emit('submit', { isVerified: this.tac === '123456' ? true : false })
      }

      axios({
        method: "POST",
        url: this.apiUrl + "/notification/verifytac",
        headers: { Authorization: "Bearer " + this.notificationAPIToken },
        data: {
          RequestorID: this.customerId,
          TACNo: this.tac,
          Purpose: this.purpose
        }
      })
      .then(resp => {
        this.$set(this, "isVerified", resp.data.isSuccessful);
        this.$emit('submit', { isVerified: this.isVerified })
      })
      .catch(err => {
        console.log(err);
        this.$set(this, "isVerified", false);
        this.$q.dialog({
          title: 'Error',
          message: `There seems to be a problem verifying your tac. Please try again later.`,
          persistent: true
        })
      });

    },

    countDownTimer() {
        if (this.timer > 0) {
          setTimeout(() => {
              this.timer -= 1
              this.countDownTimer()
          }, 1000)
        }
        else {
          this.isRequesting = false
        }
    },

    cancel() {
      // Emit tac cancel
      this.$emit('cancel', 'Tac cancelled.')
    }
  },

  computed: {
    countDownTimerMask() {
      let minutes = Math.floor(this.timer / 60);
      let seconds = this.timer - minutes * 60;

      return minutes + ' minutes ' + seconds + ' seconds'
    },

    mobileNoMask() {

      if (this.mobileNo === '') {
        return false
      }

      return this.mobileNo
        .replace(/^\+[0-9]/g, '')
        .replace(/\W/g, "")
        .replace(/\d(?!\d{0,3}$)/g, '#')

    }
  },

  mounted() {
    axios({
      method: 'GET',
      url: this.apiUrl + '/cif/' + this.customerId + '/enquiry/customerinformation',
      headers: { Authorization: 'Bearer ' + this.cifAPIToken }
    })
    .then(resp => {

      let mobileNo = resp.data.CIF.CustomerDetail.TelMobile ? resp.data.CIF.CustomerDetail.TelMobile : ''

      if (mobileNo === '') {
        return this.$q.dialog({
          title: 'Error',
          message: `There seems to be a problem retrieving your mobile number. Please try again later.`,
          persistent: true
        })
      }

      this.$set(this, 'mobileNo', mobileNo)
    })
    .catch(err => {
      this.$q.dialog({
        title: 'Error',
        message: `There seems to be a problem retrieving your mobile number. Please try again later.`,
        persistent: true
      })
    })
  }

};
</script>

<style lang="css" scoped>
.tac-btn {
  width: inherit !important;
}
@media only screen and (max-width: 599px) {
  .tac-image {
    text-align: center !important;
  }

  .tac-btn {
    text-align: right !important;
  }
}
</style>
